import React from 'react';

const FormattedProperty = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function getFormatted(value) {
    switch (props.type) {
      case 'address':
        return (
          <div>
            {value.address}
            <br />
            {value.city}, {value.state} {value.zipCode}
          </div>
        );
      /* // TODO: Make emails clickable?
      case 'email':
        return (
          <div>
            <a href="mailto:{value.email}">{value.email}</a>
          </div>
        );
        */
      default:
        return value;
    }
  }

  return (
    <div className="property">
      {props.children}
      <span className="property__label">{props.label}</span>
      <span className="property__value">{getFormatted(props.value)}</span>
    </div>
  );
};

export default FormattedProperty;
